import { render, staticRenderFns } from "./group-select.vue?vue&type=template&id=7f235a7b&"
import script from "./group-select.vue?vue&type=script&lang=js&"
export * from "./group-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports